import { render, staticRenderFns } from "./BranchListTabsItems.vue?vue&type=template&id=5b01334c&scoped=true"
import script from "./BranchListTabsItems.vue?vue&type=script&lang=js"
export * from "./BranchListTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b01334c",
  null
  
)

export default component.exports